(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hw-main-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initCrossShop(){
    document.querySelectorAll('[data-hb-cross-shop]').forEach(function(root){
      if(root.dataset.hbCrossReady)return;
      root.dataset.hbCrossReady='true';
      var track=root.querySelector('.hb-cross-shop__track');
      var controls=root.querySelector('.hb-cross-shop__controls');
      var prev=root.querySelector('[data-hb-cross-prev]');
      var next=root.querySelector('[data-hb-cross-next]');
      function update(){
        var max=track.scrollWidth-track.clientWidth;
        controls.hidden=max<2;
        prev.disabled=track.scrollLeft<=2;
        next.disabled=track.scrollLeft>=max-2;
      }
      function move(direction){
        var card=track.querySelector('.hb-cross-shop__card');
        if(!card)return;
        var distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left:direction*distance,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      prev.addEventListener('click',function(){move(-1)});
      next.addEventListener('click',function(){move(1)});
      track.addEventListener('scroll',update,{passive:true});
      if('ResizeObserver' in window){new ResizeObserver(update).observe(track)}else{window.addEventListener('resize',update)}
      update();
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initCrossShop)}else{initCrossShop()}
  document.addEventListener('shopify:section:load',initCrossShop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hw-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const initSliders = (root) => {
      root.querySelectorAll('[data-section-type="hw-product-recommendations"]').forEach((section) => {
        if (section.dataset.carouselInitialized) return;
        const track = section.querySelector('.hw-rec-slider-track');
        const previous = section.querySelector('.hw-arrow-left');
        const next = section.querySelector('.hw-arrow-right');
        if (!track || !previous || !next) return;
        section.dataset.carouselInitialized = 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const move = (direction) => {
          const card = track.querySelector('.hw-rec-card');
          const distance = card ? card.getBoundingClientRect().width + 20 : 280;
          const maximum = track.scrollWidth - track.clientWidth;
          const behavior = reducedMotion.matches ? 'auto' : 'smooth';
          if (direction < 0 && track.scrollLeft <= 10) {
            track.scrollTo({ left: maximum, behavior });
          } else if (direction > 0 && track.scrollLeft >= maximum - 10) {
            track.scrollTo({ left: 0, behavior });
          } else {
            track.scrollBy({ left: direction * distance, behavior });
          }
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initSliders(document), { once: true });
    } else {
      initSliders(document);
    }
    document.addEventListener('shopify:section:load', (event) => initSliders(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initBoxContents(root) {
      root.querySelectorAll('.hw-product-section .hw-product-short-desc').forEach((description) => {
        if (description.querySelector('.hw-box-contents')) return;
        const heading = Array.from(description.children).find((child) =>
          child.textContent.trim().toLowerCase().replace(/:$/, '').trim() === 'everything included in this box'
        );
        if (!heading || !heading.nextElementSibling) return;
        const details = document.createElement('details');
        details.className = 'hw-box-contents';
        const summary = document.createElement('summary');
        summary.textContent = heading.textContent.trim();
        const body = document.createElement('div');
        body.className = 'hw-box-contents-body';
        while (heading.nextSibling) body.append(heading.nextSibling);
        details.append(summary, body);
        heading.replaceWith(details);
      });
    }
    initBoxContents(document);
    document.addEventListener('shopify:section:load', (event) => initBoxContents(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
